<!--   图像阅读页  -->
<template>
  <div>
    <div id="imgConvas">
      <div id="imgConvas_left">
        <div id="img_loading" v-show="showLoad">
          <div><img src="static/images/loading.gif" /></div>
        </div>
        <div id="imgPan" v-show="!showLoad">
        <!--
        <div id="qpdiv">
            <i title="全屏" @click="showImageModal" class="el-icon-full-screen"></i>
        </div>
        -->
        <!--
          <div id="fanye_left" class="fanye">
            <i
              title="上图"
              @click="openPreImage"
              class="el-icon-d-arrow-left"
            ></i>
          </div>
          <div id="fanye_right" class="fanye">
            <i
              title="下图"
              @click="openNextImage"
              class="el-icon-d-arrow-right"
            ></i>
          </div>
           -->
          <div id="img_box" :class="{gaoliang: glKey, huidu: hdKey, fanse: fsKey, duibidui: dbdKey}">
            <img class="kiki"
                id="bimg"
                ref="imgObj"
                :src="imageSrc"
                @load="imageLoadOver"
                @error="wait500MillAndReTryToShowImage"
            />
            <!--
            <span class="l-corner l-tl"></span>
            <span class="l-corner l-tr"></span>
            <span class="l-corner l-bl"></span>
            <span class="l-corner l-br"></span>
            -->
          </div>
          <ul v-show="showFlags" id="flags">
                <li
                :id="i"
                v-for="(item, i) in noteList"
                :key="item.unId"
                @click="openTheNote(i)"
                class="flagTag el-icon-s-flag"
                ></li>
          </ul>
          <!--   -->
          <iframe id="iframeImgId2" :src="imageSrc" frameborder="0" style="display: none;"></iframe>

          <div
            id="toolPan"
            class="el-image-viewer__btn el-image-viewer__actions"
            style="width:420px;"
          >
            <div class="el-image-viewer__actions__inner" @mouseenter="checkHasOwnThisImgFun">
                <i title="缩小" @click="zoom(true)" class="el-icon-zoom-out"></i>
                <i title="放大" @click="zoom(false)" class="el-icon-zoom-in"></i>

                <i title="全屏" @click="showImageModal" class="el-icon-full-screen"></i>

                <i title="复位" @click="zoomReset()" class="el-icon-rank"></i>
                <i title="逆时针旋转" @click="xuanzhuan(0)" class="el-icon-refresh-left"></i>
                <i title="顺时针旋转" @click="xuanzhuan(1)" class="el-icon-refresh-right"></i>
                <!--
                <i title="打印" @click="printImage" class="el-icon-printer"></i>
                -->
                <div class="dropdown" style="display: none;">
                    <i @click="setImage()" class="el-icon-setting dropbtn"></i>
                    <div class="dropdown-content">
                    <a @click="changeClass(1)">去 灰</a>
                    <a @click="changeClass(2)">高 亮</a>
                    <a @click="changeClass(3)">反 色</a>
                    <!--
                    <a @click="changeClass(4)">对比度</a>
                    -->
                    <a @click="changeClass(0)">还 原</a>
                    </div>
                </div>
            </div>
        </div>
          <!--   -->
        </div>
      </div>
      <div class="imgConvas_right">
        <div class="imgInfoPan">
          <div>
            <InnerImageInfoCom
              :imgName="imgName"
              :idraw="idraw"
              :imark="imark"
              :isrc="isrc"
              :isrc1="isrc1"
              :isrc2="isrc2"
              :isrc3="isrc3"
              :srcImgUrl="srcImgUrl"
              :label="label"
              :maker="maker"
              :publishTime="publishTime"
              />
          </div>
          <div>
            <InnerUserButtonsCom ref="userButtonCom"
              :imgId="imgId"
              :changeCollectionIconState="flipStateToInitCollectionIcon"
              :nowImgInfo="imgName +':' +isrc +':' +idraw +':' +imark +':' +iClass +':' +titleG +':' +clearBG +':'"
              @goBackEvent="jump2Back"
              @downloadEvent="downloadImageFun"
              @changeBgEvent="changeBackgroundImageSrc"
              @addFlag="addFlag"
              />
          </div>
        </div>
      </div>
      <notePan ref="notepan" @initNotesEvent="initNotes" @updateNoteEvent="updateNoteFromArray" @delNoteEvent="removeNoteFromArray"></notePan>
    </div>
    <div>
      <el-dialog v-model="downloadTipInfoDialogVisible" width="25%">
        <DownTipInfo :imageId="imgId" :imageName="imgName"></DownTipInfo>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import config from '@/util/config.js'
import downTipInfo from './rely/downTipInfo'
import InnerUserButtonsCom from './rely/innerUserButtons.vue'
import InnerImageInfoCom from './rely/innerImageInfo.vue'

import notePan from '@/components/image/imgModal/modalRely/note'
// 调用外部js 文件里的函数 操作DOM {unId: 4, relY: 0, relX: 0, info: "edede"}
import { zoomAndDrag, suitToImgPan, zoomImage } from '@/util/tool.js'


export default {
  emits: ['imageLoadOverEvent', 'showBarreList'],
  props: {
  },
  mounted () {

    const _type = this.$store.state.globalObj.searchType
    const _key = this.$store.state.globalObj.searchKeyWords
    const _totalPage = this.$store.state.globalObj.totalPage
    const _curPage = this.$store.state.globalObj.currPageNo

    this.currPageNo = _curPage
    this.totalPage = _totalPage
    this.searchType = _type
    this.searchWord = _key

    this.swImgs = this.$store.state.globalObj.swImgs // 组件加载后 把检索结果的图像数组赋值给当前数组 准备翻页用
    this.iPos = this.$store.state.globalObj.pos // 当前图像在检索结果数组中的游标位置，翻页用

    // 用on事件来接收参数 单输入框    检索框检索触发   第N次
    document.onkeydown = event => {
      // eslint-disable-next-line no-caller
      const e = event || window.event || arguments.callee.caller.arguments[0]
      if (e && e.keyCode === 37) {
        this.openPreImage()
      }
      if (e && e.keyCode === 39) {
        debugger
        this.openNextImage()
      }
    }
    this.mountedFun()
  },
  data () {
    return {
      vueId: 'oneImageInfoShow.vue',
      isrc: '',
      imgId: '',
      imgName: '',
      isrc1: '',
      isrc2: '',
      isrc3: '',
      idraw: '',
      imark: '',
      label: '',
      srcImgUrl: '',
      showLoad: false,
      imageSrc: '',
      // swImgs: [], // 检索结果集
      iPos: 0, // 当前页面翻页浏览图像 图像数组游标
      iClass: '', // 子类
      titleG: '', // 图像组名
      clearBG: '', // 是否有背景色 0无1有
      flipStateToInitCollectionIcon: false,
      downloadTipInfoDialogVisible: false,
      withBackground: false,
      maker: '',
      publishTime: '',
      swImgs: Array,
      currPageNo: 1, // 检索结果查询当前所属页码
      totalPage: 0, // 检索结果总页数
      searchType: '', // 检索类型
      searchWord: '', // 检索词
      loadTag: false, // 是否在本页通过鼠标翻页 根据检索词翻了页 如果翻了 那么向前翻页的时候也得翻，没翻的话swImgs得第一条就是检索结果的第一张
      keyforword: true, // （下一页是前） 向前翻还是向后翻，如果是向前翻（已经向后翻过页了）那么将要显示的图片应该数组的最后一张
      xuzhuanTag: 0,
      showFlags: false,
      notice: {
        imgLeft: 0, // 现在图像左距离
        imgTop: 0 // 现在图像距顶
      },
      penShow: false, // 加标注模式
      noteList: [], // 签注列表

      glKey: false, // 滤镜之高亮
      hdKey: false, // 滤镜之灰度
      fsKey: false, // 滤镜之反色
      dbdKey: false, // 滤镜之对比度

      imgH: 0, // 原始图高
      imgW: 0, // 原始图宽
      imgRatio: 0.8, // 现在缩放后和原始大小的比例

      refreshTimeOutAddr: null

    }
  },
  methods: {

    searchImages (keyWord, typeClass, pageNo) {
      if ((typeClass != null && typeClass.length < 1) || typeClass === 'all') {
        typeClass = ''
      }
      const api = '/md/front/paid/image/multiSearch'
      const params = {
        kword: keyWord,
        itype: typeClass,
        pageSize: 50,
        pageNo: pageNo,
        rebackCount: 0
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status !== 200) {
          return
        }
        res = res.data
        const resMap = res
        if (resMap.flag) {
          if (resMap.data != null) {
            this.swImgs = resMap.data
            console.log('重新加载了：' + this.swImgs.length + '张图片')
            // this.$alert(this.swImgs.length)
            if (this.keyforword) {
              this.iPos = 0 // 数组重新赋值 游标从0开始
            } else {
              this.iPos = this.swImgs.length - 1 // 数组重新赋值 游标从0开始
            }
            this.openThePage()
          } else {
            this.swImgs = []
            this.$alert('么有了')
          }
        } else {
          this.$alert(resMap.info, '提示')
        }
      })
    },
    refreshNotes () {
      // this.$alert('shuaxin')
      clearTimeout(this.refreshTimeOutAddr)
      // 加了这个定时器后防止一直滚动滑轮出现批注旗子闪烁的情况(同时滑动图片的时候旗子更加自然)
      this.refreshTimeOutAddr = setTimeout(() => {
        // eslint-disable-next-line no-debugger

        this.showFlags = false
        const alist = document.getElementsByClassName('flagTag')
        let x, y
        if (alist != null && alist.length > 0) {
          for (let i = 0; i < alist.length; i++) {
            const o = this.noteList[i]
            const obj = alist[i]
            console.log('---------------------------------------' + this.notice.imgLeft + '----' + this.notice.imgTop)
            x = o.relX * this.imgRatio + this.notice.imgLeft
            y = o.relY * this.imgRatio + this.notice.imgTop
            obj.style.left = x + 'px'
            obj.style.top = y + 'px'
          }
        }
        this.showFlags = true
        // this.$alert(this.showFlags)
      }, 500)
    },
    resetTopAndLeft (imgLeft, imgTop) {
      this.notice.imgLeft = imgLeft
      this.notice.imgTop = imgTop
    },
    colseAddFlag () {
      this.$refs.imgObj.style.cursor = 'auto'
      this.$refs.imgObj.style.cursor = 'default'
      this.penShow = false
    },
    initNoteAndFlag (imgX, imgY) { // tool.js里面拖动函数有调用这个初始化方法(每次拖动都必须重新计算相对位置)
      // 画笔点击图片后触发
      this.$refs.notepan.showAddNotePan(this.imgId, imgX, imgY)
    },
    initNotes (notelist) {
      this.noteList = notelist
      setTimeout(() => {
        this.refreshNotes() // 刷新位置
      }, 1000)
    },
    removeNoteFromArray (index) {
      this.noteList.splice(index, 1)
    },
    updateNoteFromArray (index, vstr) {
      this.noteList[index].info = vstr
    },
    openTheNote (i) {
      const info = this.noteList[i]
      this.showOpNotePan(i, info)
    },
    showOpNotePan (index, objv) {
      // 打开更新或删除面板
      this.$refs.notepan.showOpNotePan(index, this.imgId, objv)
    },
    addFlag () {
      // this.$alert('确定标注!!!!!!!')
      this.$refs.imgObj.style.cursor = 'url("' + config.relatedPath() + 'static/images/shubiao.png"), auto'
      this.penShow = true
    },
    zoom (tag) {
      zoomImage(tag)
    },
    zoomReset () {
      this.showFlags = true
      this.xuzhuanTag = 0
      this.$refs.imgObj.style.transform = 'rotate(' + this.xuzhuanTag + 'deg)' // deg)后面绝对不能加分号, 否则旋转无效
      const oImg = this.$refs.imgObj
      const oParent = oImg.parentNode
      suitToImgPan(
        oParent.clientHeight,
        oParent.clientWidth,
        oImg.height,
        oImg.width,
        'bimg',
        2,
        2
      )
    },
    xuanzhuan (id) {
      if (id === 1) {
        // 正转
        this.xuzhuanTag = this.xuzhuanTag + 90
      } else {
        // 倒转
        this.xuzhuanTag = this.xuzhuanTag - 90
      }
      this.showFlags = (this.xuzhuanTag % 360) === 0
      this.$refs.imgObj.style.transform = 'rotate(' + this.xuzhuanTag + 'deg)' // deg)后面绝对不能加分号, 否则旋转无效
    },
    printImage () {
      // 之前使用的是一个vue2的打印插件, 打印的方法都是调用window或者iframe对象的系统打印方法
      const iframe = document.getElementById('iframeImgId2')
      const doc = iframe.contentDocument
      doc.open()
      doc.write('<img src="' + this.imageSrc + '" style="height: 95vh; width: auto" />')
      doc.close()
      iframe.contentWindow.focus()
      iframe.contentWindow.print()
    },
    setImage () {},
    changeClass (id) {
      switch (id) {
        case 1:
          this.glKey = false
          this.hdKey = true
          this.fsKey = false
          this.dbdKey = false
          break
        case 2:
          this.glKey = true
          this.hdKey = false
          this.fsKey = false
          this.dbdKey = false
          break
        case 3:
          this.glKey = false
          this.hdKey = false
          this.fsKey = true
          this.dbdKey = false
          break
        case 4:
          this.glKey = false
          this.hdKey = false
          this.fsKey = false
          this.dbdKey = true
          break
        default:
          this.glKey = false
          this.hdKey = false
          this.fsKey = false
          this.dbdKey = false
      }
    },
    openBigImg (imgId, imgInfo, tag, reFreshGroupImg) {
      this.reFreshGroupImg = reFreshGroupImg // 组图的刷新在上一级
      this.imgId = imgId
      let kk = []
      kk = imgInfo.split(':')
      this.imgName = kk[0]
      this.isrc = kk[1]
      if (this.isrc != null && this.isrc.length > 0) {
        const arr = this.isrc.split('@')
        if (arr != null && arr.length === 3) {
          this.isrc1 = arr[0]
          this.isrc2 = arr[1]
          this.isrc3 = arr[2]
        }
      }

      this.idraw = kk[2]
      this.imark = kk[3]
      this.iClass = kk[4]
      this.titleG = kk[5] + '' === 'null' ? '暂无' : kk[5]
      this.clearBG = kk[6]

      // 读取原始图片
      if (tag !== undefined && tag === '1') {
        this.imgSrcLoadType = 1
      } else {
        this.imgSrcLoadType = 0
      }
      this.getSrcImg() // 加载原书图

      // alert(this.imgName)
      this.showLoad = true
      const imgUrl = '/md/front/paid/img/view/'

      this.imageSrc =
        imgUrl +
        imgId +
        '/' +
        encodeURI(imgInfo) +
        '?withBackground=' +
        this.withBackground +
        '&randomTime=' +
        Date.now()
      this.isNoResult = false
    },
    getSrcImg () {
      const label = null
      const level = null
      if (level !== null && level !== 'null') {
        this.label = level + '   ' + label
      } else {
        this.label = label
      }
      // this.isrc = localStorage.getItem('isrc')
      // this.idraw = localStorage.getItem('idraw')
      // this.imark = localStorage.getItem('imark')

      // let ss = posSrc + '----' + lenSrc + '----' + label + '----' + level
      const imgurl = '/md/front/paid/img/'
      if (this.imgSrcLoadType === 0) {
        // this.srcImgUrl = imgurl + 'swimg/' + posSrc + '/' + lenSrc
        this.srcImgUrl = imgurl + 'samllimg/' + this.imgId + '/0'
      } else {
        this.srcImgUrl = imgurl + 'samllimg/' + this.imgId + '/0'
      }
    },
    showImageModal () {
      let imgInfo =
        this.imgName +
        ':' +
        this.isrc +
        ':' +
        this.idraw +
        ':' +
        this.imark +
        ':'
      imgInfo =
        imgInfo + this.iClass + ':' + this.titleG + ':' + this.clearBG + ':' // 新增的3个属性
      this.$store.commit('setGlobalObjOfShowImgID', this.imgId)
      this.$store.commit('setGlobalObjOfShowImgInfo', imgInfo)
      this.$store.commit('flipShowImageModalState') // 激活 ImageListView.vue 之监听函数
    },
    openThePage () {
      this.flipStateToInitCollectionIcon = !this.flipStateToInitCollectionIcon // 取反即通知子组件恢复收藏按钮的默认图标
      const curA = this.swImgs[this.iPos]
      const imgid = curA.id

      this.maker = curA.maker

      this.publishTime = curA.iclass1

      let imginfo =
        curA.iname + ':' + curA.isrc + ':' + curA.idraw + ':' + curA.imark + ':'
      imginfo =
        imginfo + curA.iClass + ':' + curA.titleG + ':' + curA.clearBG + ':' // 新增的3个属性

      this.openBigImg(imgid, imginfo, null, false)
    },
    imageLoadOver () {
      // this.$alert('sss')
      // 图片加载完成后调用子组件的方法
      this.$refs.userButtonCom.checkHasOwnThisImgFun()

      const oImg = document.getElementById('bimg')
      this.showLoad = false

      this.handleImageLoadOverFun2(this.titleG, this.imgId, this.reFreshGroupImg, oImg.width, oImg.height)

      // this.$emit('imageLoadOverEvent',this.titleG,this.imgId,this.reFreshGroupImg,oImg.width,oImg.height)
    },
    handleImageLoadOverFun2 (imageTypeName, imageID, reFreshGroupImg, width, height) {
      this.titleG = imageTypeName
      this.imgId = imageID
      // this.reFreshGroupImg = reFreshGroupImg
      this.setImgSize(width, height)

      this.checkNote()
    },
    setImgSize (width, height) {
      // 大图加载完调整大图的尺寸， 同时开始读取 同类型推荐图片列表
      // this.loadNotes(this.imgId) // 加载标签
      // this.showLoad = false
      setTimeout(() => {
        try {
          // eslint-disable-next-line no-debugger

          const oImg = document.getElementById('bimg')
          this.imgH = height
          this.imgW = width
          // console.log('内嵌图片的高度和宽度: '+this.imgH + '--' + this.imgW, this.imgH/this.imgW)
          zoomAndDrag('bimg', this)
          oImg.className = 'onehand'
          const oParent = oImg.parentNode
          // alert(oParent.clientWidth + '---' + oParent.clientHeight)
          suitToImgPan(
            oParent.clientHeight,
            oParent.clientWidth,
            this.imgH,
            this.imgW,
            'bimg',
            2,
            2
          )
          /*
            // 开始加载组图
            if (this.reFreshGroupImg) {
                this.rowsArray = []
                // this.searchImages(1, this.pageSize) // 开始加载同类型推荐图片列表
            }
          */
          if (this.imgH / this.imgW < 0.1) {
            // 只有宽高比达到一定程度的时候才自动放大图片
            // console.log('执行缩放函数')
            zoomImage(false)
            zoomImage(false)
            zoomImage(false)
            zoomImage(false)
            zoomImage(false)
            zoomImage(false)
          }
        } catch (error) {
          setTimeout(() => {
            const height = this.imgH
            const width = this.imgW
            this.setImgSize(width, height)
          }, 100)
        }
      }, 100)
    },
    checkNote () {
      const isLogin = this.$store.state.globalObj.nowUserLoginState
      // 如果已经登录 则检查是否已经收藏  否则就不检查不然没意义
      if (isLogin) { // 已登录 加载标记
        this.$refs.notepan.loadNotes(this.imgId)
      }
    },
    openPreImage () {
      if (this.iPos > 0) {
        this.iPos--
        this.openThePage()
      } else {
        this.loadPrePage()
      }
    },
    openNextImage () {
      // this.loadNextPage()
      if (this.iPos < this.swImgs.length - 1) {
        this.iPos++
        this.openThePage()
      } else {
        // this.$alert('么有了')
        this.loadNextPage()
      }
    },
    loadPrePage () {
      if (this.loadTag) { // 翻过页了
        this.keyforword = false // 新的结果集出来后 展示的图是数组最后一张
        if (this.currPageNo > 1) {
          this.currPageNo--
          this.searchImages(this.searchWord, this.searchType, this.currPageNo)

        } else {
          this.$alert('么有了')
        }
        this.loadTag = false
      } else {
        this.$alert('么有了')
      }

    },
    loadNextPage () {
      // const _type = this.$store.state.globalObj.searchType
      // const _key = this.$store.state.globalObj.searchKeyWords
      // const _totalPage = this.$store.state.globalObj.totalPage
      // const _curPage = this.$store.state.globalObj.currPageNo

      // this.$alert(this.searchType + ':' + this.searchWord + ':' + this.totalPage + ':' + this.currPageNo)

      if (this.currPageNo < this.totalPage) {
        this.keyforword = true
        this.loadTag = true // 翻过页了 数组游标0不再是总结果的第一图了
        this.currPageNo++
        this.searchImages(this.searchWord, this.searchType, this.currPageNo)
      } else {
        this.$alert('么有了')
      }
    },

    wait500MillAndReTryToShowImage () {
      // 假如图像信息没问题, 仅仅是后台异常, 只需要等待后重新请求即可
      setTimeout(() => {
        this.imageSrc = this.imageSrc + '&randomTime2=' + Date.now()
      }, 200)
    },
    jump2Back () {
      this.showLoad = true
      this.rowsArray = []
      this.lastRow = []
      this.swImgsOnlyShowName = []
      this.$router
        .push({
          path: '/imgList/barrel'
        })
        .catch(() => {})
      this.$emit('showBarreList')
    },
    downloadImageFun () {
      this.downloadTipInfoDialogVisible = true
    },
    changeBackgroundImageSrc () {
      const oldSrc = this.imageSrc
      const links = oldSrc.split('?')
      const leftSrc = links[0]
      this.withBackground = !this.withBackground
      // eslint-disable-next-line no-debugger
      this.imageSrc =
        leftSrc +
        '?withBackground=' +
        this.withBackground +
        '&randomTime=' +
        Date.now()
    },
    mountedFun () {
      const imgId = this.$store.state.globalObj.showImgID
      const imgInfo = this.$store.state.globalObj.showImgInfo
      this.showLoad = true
      // eslint-disable-next-line no-debugger
      // debugger

      this.maker = this.$store.state.globalObj.maker

      this.publishTime = this.$store.state.globalObj.publishTime

      this.openBigImg(imgId, imgInfo, null, true)

      /*
      let imgInfo = this.iname + ':' + this.isrc + ':' + this.idraw + ':' + this.imark + ':'
      imgInfo = imgInfo + this.iClass + ':' + this.titleG + ':' + this.clearBG + ':' // 新增的3个属性

      this.$store.commit('setGlobalObjOfShowImgID', this.id)
      this.$store.commit('setGlobalObjOfShowImgInfo', imgInfo)
      this.$store.commit('setGlobalObjOfMaker', this.maker)
      this.$store.commit('setGlobalSwImgsPos', this.arrayPos)
      */
    }
  },
  computed: {
    showImageState () {
      return this.$store.state.events.showImageState
    }
  },
  watch: {
    showImageState () {
      this.mountedFun()
    }
  },
  components: {
    DownTipInfo: downTipInfo,
    InnerUserButtonsCom,
    InnerImageInfoCom,
    notePan
  }
}
</script>

<style scoped>
#qpdiv {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 20px;
  right: 80px;
  font-size: 30px;
  cursor: pointer;
  z-index: 999;
}

.fanye {
  font-size: 60px;
  cursor: pointer;
  z-index: 999;
  position: absolute;
  top: calc(50vh - 120px);
  display: none;
}

#fanye_left {
  left: 10px;
}
#fanye_right {
  right: 10px;
}
#imgConvas {
  width: 100%;
  height: calc(100vh - 130px);
  display: flex;
  flex-direction: row;
}

#imgConvas_left {
   /*
    background-color: #fff;
    width: 70%;
   */
   width: calc(100% - 320px);
   height: calc(100vh - 130px);
}

.imgConvas_right {
    /*
   width: 30%;
   */
   width: 320px;
   height: calc(100vh - 130px);
}

#imgPan {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
}
#img_loading {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}



.imgInfoPan {
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 18px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 10px;
}

#toolPan {
  position: absolute;
  z-index: 100;
  bottom: 10px;
}
.el-image-viewer__actions__inner i {
  cursor: pointer;
  font-size: 20px;
}

.dropbtn {
  color: white;
  font-size: 24px;
  border: none;
  cursor: pointer;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #000;
  width: 100px;
  font-size: 16px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  -moz-border-radius: 10px; /* Gecko browsers */
  -webkit-border-radius: 10px; /* Webkit browsers */
  border-radius: 10px; /* W3C syntax */
  padding: 8px 0 8px 0;
}

.dropdown-content a {
  color: #fff;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: grey;
}

.dropdown:hover .dropdown-content {
  display: block;
  bottom: 20px;
}

.dropdown :hover .dropbtn {
  background-color: #3e8e41;
}

.el-image-viewer__actions__inner i {
  cursor: pointer;
  font-size: 24px;
}

.gaoliang {
  -webkit-filter: brightness(200%); /* Chrome, Safari, Opera */
  filter: brightness(200%);
}
.huidu {
  -webkit-filter: grayscale(80%); /* Chrome, Safari, Opera */
  filter: grayscale(80%);
}
.fanse {
  -webkit-filter: hue-rotate(90deg); /* Chrome, Safari, Opera */
  filter: hue-rotate(90deg);
}
.duibidu {
  -webkit-filter: contrast(200%); /* Chrome, Safari, Opera */
  filter: contrast(200%);
}

/****标记开始****/
.flagTag {
  position: absolute;
}
#flags {
  display: block;
  width: 50px;
  height: auto;
  z-index: 2;
  background-color: transparent;
  position: absolute;
  top: 20px;
  left: 10px;
}

#flags li {
  color: red;
  font-size: 25px;
  cursor: pointer;
}



#img_box{
  width: 100%;
  height: 100%;
  position: relative;
  /*
  background: #fff;
 */
  border-radius: 12px 12px 12px 12px;
}


/* 通用 L 角 */
  .l-corner {
    position: absolute;
    width: 80px;
    height: 80px;
    pointer-events: none; /* 不挡点击 */
  }

  /* 左上角：向外溢出 5px */
  .l-tl {
    top: 0px;
    left: 0px;
    border-top: 3px solid red;
    border-left: 3px solid red;
    border-radius: 12px 0 0 0;
  }

  /* 右上角 */
  .l-tr {
    top: 0px;
    right: 0px;
    border-top: 3px solid red;
    border-right: 3px solid red;
    border-radius: 0 12px 0 0;
  }

  /* 左下角 */
  .l-bl {
    bottom: 0px;
    left: 0px;
    border-bottom: 3px solid red;
    border-left: 3px solid red;
    border-radius: 0 0 0 12px;
  }

  /* 右下角 */
  .l-br {
    bottom: 0px;
    right: 0px;
    border-bottom: 3px solid red;
    border-right: 3px solid red;
    border-radius: 0 0 12px 0;
  }


  #bimg {
    border: solid 3px #eac008;
  }
</style>
